// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

let emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function Make(Lenses) {
  let assertion = (field, comparator, error) => {
    if (comparator) {
      return;
    } else {
      return [
        {
          TAG: "Field",
          _0: field
        },
        error
      ];
    }
  };
  let validate = (schema, values) => {
    let errors = Stdlib_Array.filterMap(schema, rule => {
      switch (rule.TAG) {
        case "StringMin" :
          let min = rule._1;
          let field = rule._0;
          let value = Lenses.get(values, field);
          let error = I18n.template(I18n.t("This value must be at least {{min}} character(s)."), {
            min: min
          }, undefined);
          return assertion(field, value.length >= min, error);
        case "StringNotEmpty" :
          let field$1 = rule._0;
          let value$1 = Lenses.get(values, field$1);
          let error$1 = I18n.t("Please fulfill this field.");
          return assertion(field$1, value$1.length >= 1, error$1);
        case "OptionDefined" :
          let field$2 = rule._0;
          let value$2 = Lenses.get(values, field$2);
          let error$2 = I18n.t("Please fulfill this field.");
          return assertion(field$2, Stdlib_Option.isSome(value$2), error$2);
        case "IntRange" :
          let max = rule._2;
          let min$1 = rule._1;
          let field$3 = rule._0;
          let value$3 = Lenses.get(values, field$3);
          if (min$1 !== undefined) {
            if (max !== undefined) {
              let error$3 = I18n.template(I18n.t("This number must range between {{min}} and {{max}} inclusive."), {
                min: min$1,
                max: max
              }, undefined);
              return assertion(field$3, value$3 >= min$1 && value$3 <= max, error$3);
            }
            let error$4 = I18n.template(I18n.t("This number must be superior or equal to {{min}}."), {
              min: min$1
            }, undefined);
            return assertion(field$3, value$3 >= min$1, error$4);
          }
          if (max === undefined) {
            return;
          }
          let error$5 = I18n.template(I18n.t("This number must be inferior or equal to {{max}}."), {
            max: max
          }, undefined);
          return assertion(field$3, value$3 <= max, error$5);
        case "FloatRange" :
          let max$1 = rule._2;
          let min$2 = rule._1;
          let field$4 = rule._0;
          let value$4 = Lenses.get(values, field$4);
          if (min$2 !== undefined) {
            if (max$1 !== undefined) {
              let error$6 = I18n.template(I18n.t("This number must range between {{min}} and {{max}} inclusive."), {
                min: min$2,
                max: max$1
              }, undefined);
              return assertion(field$4, value$4 >= min$2 && value$4 <= max$1, error$6);
            }
            let error$7 = I18n.template(I18n.t("This number must be superior or equal to {{min}}."), {
              min: min$2 - 1
            }, undefined);
            return assertion(field$4, value$4 >= min$2, error$7);
          }
          if (max$1 === undefined) {
            return;
          }
          let error$8 = I18n.template(I18n.t("This number must be inferior or equal to {{max}}."), {
            max: max$1 + 1
          }, undefined);
          return assertion(field$4, value$4 <= max$1, error$8);
        case "PhoneNumber" :
          let field$5 = rule._0;
          let re = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
          let value$5 = Lenses.get(values, field$5);
          let error$9 = I18n.t("This value is not a valid phone number.");
          return assertion(field$5, re.test(value$5), error$9);
        case "Email" :
          let field$6 = rule._0;
          let value$6 = Lenses.get(values, field$6);
          let error$10 = I18n.t("Invalid email address.");
          return assertion(field$6, emailRegex.test(value$6), error$10);
        case "OptionalEmail" :
          let field$7 = rule._0;
          let value$7 = Lenses.get(values, field$7).trim();
          let error$11 = I18n.t("Invalid email address.");
          return assertion(field$7, value$7 === "" || emailRegex.test(value$7), error$11);
        case "Password" :
          let field$8 = rule._0;
          let re$1 = /^(?=.{10,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).*$/;
          let value$8 = Lenses.get(values, field$8);
          let error$12 = I18n.t("Invalid password.");
          return assertion(field$8, re$1.test(value$8), error$12);
        case "Custom" :
          let error$13 = rule._1(values);
          if (error$13.TAG === "Ok") {
            return;
          } else {
            return [
              {
                TAG: "Field",
                _0: rule._0
              },
              error$13._0
            ];
          }
        case "CustomString" :
          let field$9 = rule._0;
          let error$14 = rule._1(Lenses.get(values, field$9), values);
          if (error$14.TAG === "Ok") {
            return;
          } else {
            return [
              {
                TAG: "Field",
                _0: field$9
              },
              error$14._0
            ];
          }
        case "ArrayMin" :
          let min$3 = rule._1;
          let field$10 = rule._0;
          let value$9 = Lenses.get(values, field$10);
          let stringLiteral = I18n.t("This value must contain at least {{min}} item(s).");
          let error$15 = I18n.template(stringLiteral, {
            min: min$3
          }, undefined);
          return assertion(field$10, value$9.length >= min$3, error$15);
      }
    });
    if (errors.length === 0) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: errors
      };
    }
  };
  let isValidField = (validation, field) => {
    if (validation.TAG === "Ok") {
      return true;
    } else {
      return !validation._0.some(param => Primitive_object.equal(param[0], {
        TAG: "Field",
        _0: field
      }));
    }
  };
  let required = (schema, field) => schema.some(rule => {
    switch (rule.TAG) {
      case "OptionalEmail" :
        return false;
      case "OptionDefined" :
      case "IntRange" :
      case "FloatRange" :
      case "Custom" :
      case "ArrayMin" :
        break;
      default:
        return Primitive_object.equal({
          TAG: "Field",
          _0: rule._0
        }, {
          TAG: "Field",
          _0: field
        });
    }
    return Primitive_object.equal({
      TAG: "Field",
      _0: rule._0
    }, {
      TAG: "Field",
      _0: field
    });
  });
  return {
    assertion: assertion,
    validate: validate,
    isValidField: isValidField,
    required: required
  };
}

export {
  emailRegex,
  Make,
}
/* I18n Not a pure module */
